/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {seedNextBestAction} from '../api'

export const useMutationSeedNextBestAction = createReactQueryMutationHook('seedNextBestAction', seedNextBestAction)
